import React from 'react';
import { Package, Gift } from 'lucide-react';
import { Section } from './ui/Section';
export function ValueStackSection() {
  return <Section className="px-6 md:px-12 max-w-3xl mx-auto" data-id="element-259">
      <div className="text-center mb-12" data-id="element-260">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-100" data-id="element-261">
          Stack de Valor Total
        </h2>
      </div>

      <div className="border border-[#b8860b]/30 bg-[#0a0a0a] rounded-sm overflow-hidden" data-id="element-262">
        <div className="p-6 md:p-8 space-y-6" data-id="element-263">
          {/* Main Product */}
          <div className="flex items-center justify-between pb-6 border-b border-gray-800" data-id="element-264">
            <div className="flex items-center space-x-4" data-id="element-265">
              <div className="p-2 bg-[#111827] border border-gray-800 rounded-sm" data-id="element-266">
                <Package className="w-5 h-5 text-gray-400" data-id="element-267" />
              </div>
              <span className="font-sans text-lg text-gray-200" data-id="element-268">
                Producto Principal
              </span>
            </div>
            <span className="font-mono text-gray-400" data-id="element-269">$97 USD</span>
          </div>

          {/* Bonuses */}
          <div className="space-y-4 pb-6 border-b border-gray-800" data-id="element-270">
            <div className="flex items-center justify-between" data-id="element-271">
              <div className="flex items-center space-x-4" data-id="element-272">
                <div className="p-2 bg-[#d4a853]/10 border border-[#d4a853]/20 rounded-sm" data-id="element-273">
                  <Gift className="w-5 h-5 text-[#d4a853]" data-id="element-274" />
                </div>
                <span className="font-sans text-gray-300" data-id="element-275">
                  Bono #1 — El Mapa de 30 Minutos
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-276">
                <span className="font-mono text-gray-500 line-through decoration-red-500/50" data-id="element-277">
                  $27 USD
                </span>
                <span className="font-mono font-bold text-[#d4a853] text-sm tracking-widest" data-id="element-278">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-279">
              <div className="flex items-center space-x-4" data-id="element-280">
                <div className="p-2 bg-[#d4a853]/10 border border-[#d4a853]/20 rounded-sm" data-id="element-281">
                  <Gift className="w-5 h-5 text-[#d4a853]" data-id="element-282" />
                </div>
                <span className="font-sans text-gray-300" data-id="element-283">
                  Bono #2 — Biblioteca de Respuestas Blindadas
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-284">
                <span className="font-mono text-gray-500 line-through decoration-red-500/50" data-id="element-285">
                  $37 USD
                </span>
                <span className="font-mono font-bold text-[#d4a853] text-sm tracking-widest" data-id="element-286">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-287">
              <div className="flex items-center space-x-4" data-id="element-288">
                <div className="p-2 bg-[#d4a853]/10 border border-[#d4a853]/20 rounded-sm" data-id="element-289">
                  <Gift className="w-5 h-5 text-[#d4a853]" data-id="element-290" />
                </div>
                <span className="font-sans text-gray-300" data-id="element-291">
                  Bono #3 — El Kit Anti-Caos
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-292">
                <span className="font-mono text-gray-500 line-through decoration-red-500/50" data-id="element-293">
                  $27 USD
                </span>
                <span className="font-mono font-bold text-[#d4a853] text-sm tracking-widest" data-id="element-294">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          {/* Total Value */}
          <div className="flex items-center justify-between pt-2" data-id="element-295">
            <span className="font-mono font-bold tracking-widest uppercase text-gray-400" data-id="element-296">
              Valor Total
            </span>
            <span className="font-mono font-bold text-xl text-gray-400 line-through decoration-red-500/50 decoration-2" data-id="element-297">
              $188 USD
            </span>
          </div>
        </div>

        {/* Today's Price */}
        <div className="bg-[#d4a853]/10 border-t border-[#d4a853]/30 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between" data-id="element-298">
          <span className="font-serif text-2xl md:text-3xl font-bold text-[#f0c674] mb-2 md:mb-0" data-id="element-299">
            HOY PAGÁS
          </span>
          <div className="flex items-center space-x-4" data-id="element-300">
            <span className="font-mono text-2xl md:text-3xl text-gray-500 line-through decoration-red-500/60 decoration-2" data-id="element-301">
              $47 USD
            </span>
            <span className="font-mono text-4xl md:text-5xl font-bold text-[#f0c674] text-glow" data-id="element-302">
              $6 USD
            </span>
          </div>
        </div>
      </div>
    </Section>;
}